module.exports = __webpack_public_path__ + "img/llh_icon.aea00f53.svg";